<template>
  <div class="contact-us-container">
    <div class="contact-image-container">
      <img 
        :src="contactImage" 
        alt="联系我们" 
        class="contact-image"
      />
    </div>
    <CallMe />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'

export default {
  name: 'ContactUs',
  components: {
    CallMe
  },
  data() {
    return {
      contactImage: require('@/assets/img/call_me.png')
    }
  }
}
</script>

<style scoped>
.contact-us-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}

.contact-image-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #f5f5f5;
  overflow: hidden;
  position: relative;
}

.contact-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}
</style>
